import React from 'react';
import { useCampaignForm } from '../context/CampaignFormContext';

export const CopyHistorySidebar: React.FC = () => {
  const { copyHistory, applyCopy } = useCampaignForm();

  if (copyHistory.length === 0) {
    return (
      <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
        <h4 className="font-semibold mb-4 flex items-center gap-2">
          🕐 Copy History
        </h4>
        <p className="text-gray-500 text-sm">
          No history yet. Generate AI copy or manually edit to start tracking versions.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke max-h-[600px] overflow-y-auto">
      <h4 className="font-semibold mb-4 flex items-center gap-2">
        🕐 Copy History ({copyHistory.length} versions)
      </h4>

      <div className="space-y-3">
        {copyHistory.slice().reverse().map((version, index) => (
          <div
            key={version.id}
            className="p-4 border border-stroke rounded-lg hover:border-primary cursor-pointer transition-colors"
            onClick={() => applyCopy({
              headline: version.headline,
              description: version.description,
              cta: version.cta
            }, version.aiSuggestionId)}
          >
            <div className="flex justify-between items-center mb-2">
              <span className="text-xs text-gray-500">
                {new Date(version.appliedAt).toLocaleString()}
              </span>
              {version.source === 'ai' && (
                <span className="flex items-center gap-1 text-xs bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 px-2 py-1 rounded">
                  ✨ AI Generated
                </span>
              )}
            </div>
            <p className="text-sm font-medium truncate mb-1">{version.headline}</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 truncate">{version.description}</p>
            <p className="text-xs text-primary mt-1">CTA: {version.cta}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
